import { render, staticRenderFns } from "./EditActivityFeesModal.vue?vue&type=template&id=645c83d8&scoped=true&"
import script from "./EditActivityFeesModal.vue?vue&type=script&lang=js&"
export * from "./EditActivityFeesModal.vue?vue&type=script&lang=js&"
import style0 from "./EditActivityFeesModal.vue?vue&type=style&index=0&id=645c83d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645c83d8",
  null
  
)

export default component.exports